import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { ExperienceI18nService } from '../../core/experience/experience-i18n.service';

@Pipe({
    name: 'exp',
    pure: false,
    standalone: false,
})
export class ExperienceTranslatePipe implements PipeTransform {
    private localeVersion = 0;

    constructor(
        private readonly experienceI18n: ExperienceI18nService,
        private readonly changeDetectorRef: ChangeDetectorRef,
    ) {
        this.experienceI18n.localeChanged$.subscribe(() => {
            this.localeVersion += 1;
            this.changeDetectorRef.markForCheck();
        });
    }

    transform(
        key: string,
        params?: Record<string, string | number> | string,
        fallback?: string,
    ): string {
        void this.localeVersion;
        const resolvedParams =
            params && typeof params === 'object' ? params : undefined;
        const resolvedFallback =
            typeof params === 'string' && params !== '' ? params : fallback;
        const translated = this.experienceI18n.translate(key, resolvedParams);
        if (translated === key && resolvedFallback) {
            return resolvedFallback;
        }
        return translated;
    }
}
